/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

! function() {
    "use strict";

    angular.module('webReader').service('HighlightsModel', constructor);

    function constructor(NetworkService, DocumentModel, DocumentService, HighlightsService) {
        var self = this;
        var highlightsCollection = [];
        var temporaryHighlightsCollection = {};
        var docPath = '';
        var onHighlightsUpdate = [];
        var onHighlightLoaded = {};
        var onHighlightsLoaded = [];
        var chaptersPromises = {};


        angular.extend(self, {
            subscribe: {
                onHighlightsUpdate: function(callbackFunction) {
                    onHighlightsUpdate.push(callbackFunction);
                },
                onHighlightsLoaded: function(callbackFunction) {
                    onHighlightsLoaded.push(callbackFunction);
                },
                onHighlightLoaded: function(highlightIndex, callBackFunction) {
                    if (_.isUndefined(onHighlightLoaded[highlightIndex])) {
                        onHighlightLoaded[highlightIndex] = [];
                    }

                    onHighlightLoaded[highlightIndex].push(callBackFunction);
                    return onHighlightLoaded[highlightIndex].length - 1;
                }
            },
            unsubscribe: {
                onHighlightLoaded: function(highlightIndex, callbackId) {
                    if (!_.isNull(onHighlightLoaded[highlightIndex]) &&
                        !_.isNull(onHighlightLoaded[highlightIndex][callbackId])) {
                        onHighlightLoaded[highlightIndex][callbackId] = null;
                    }
                },
            },

            executeSubscriptions: function(callbacks, args) {
                var self = this;
                return _.every(callbacks, function(fn) {
                    if (!_.isNull(fn)) {
                        return fn.apply(self, [args]) !== false;
                    }
                })
            },

            checkIf: {
                isHighlightLoaded: function(highlightIndex) {
                    return !!highlightsCollection[highlightIndex] && highlightsCollection[highlightIndex].status === 'LOADED';
                }
            },

            create: function() {
                DocumentModel.subscribe.onModelUpdate(function() {
                    NetworkService.getHighlights(DocumentModel.getDocumentPath()).then(self.invoke);
                });
            },
            invoke: function(data) {
                highlightsCollection = _.filter(data, function(el) {
                    //filter only highlights
                    return !!el.type && el.type === 'highlight';
                });

                _.each(highlightsCollection, function(el, i) {
                    el.index = i;
                    NetworkService.getHighlight(DocumentModel.getDocumentPath(), el.uuid).then(self.updateHighlight(i));
                });
                self.executeSubscriptions.call(this, onHighlightsUpdate, []);
            },
            updateHighlight: function(highlightIndex) {
                var _highlightIndex = highlightIndex;

                highlightsCollection[highlightIndex].status = 'LOADING';
                return function(data) {
                    highlightsCollection[_highlightIndex] = data;
                    highlightsCollection[_highlightIndex].status = 'LOADED';
                    self.executeSubscriptions.call(this, onHighlightLoaded[_highlightIndex], []);
                    data.position = {
                        start_pointer: DocumentService.parseCfiPosition(data.quotation.begin),
                        end_pointer: DocumentService.parseCfiPosition(data.quotation.end)
                    };
                    var chapterIndex = DocumentModel.getChapterIdByUrl(data.position.start_pointer.url);

                    if (DocumentModel.checkIf.isChapterRendered(chapterIndex)) {
                        HighlightsService.createHighlight(data, chapterIndex);
                    } else {
                        chaptersPromises[chapterIndex] = DocumentService.subscribe.onChapterRendered(chapterIndex, (function() {
                            var chapterPromise = chaptersPromises[chapterIndex];
                            var chapterId = chapterIndex;
                            var highlightObject = data;


                            return function() {
                                DocumentService.unsubscribe.onChapterRendered(chapterId, chapterPromise);
                                highlightObject.position = {
                                    start_pointer: DocumentService.parseCfiPosition(data.quotation.begin),
                                    end_pointer: DocumentService.parseCfiPosition(data.quotation.end)
                                };
                                HighlightsService.createHighlight(highlightObject, chapterId);
                            };
                        })())
                    }
                }
            },

            createTemporaryHighlight: function(documentPath, selection, selectionOffsetObject) {
                var getUniqTemporaryHighlightId = function() {
                    var result = 'tempUUID';
                    var i;

                    for (i = 0; !!temporaryHighlightsCollection[result + i.toString()]; i++) {};

                    return result + i;
                };

                var newHighlightId = getUniqTemporaryHighlightId();
                var moment = (new Date()).toUTCString();

                temporaryHighlightsCollection[newHighlightId] = {
                    "uuid": newHighlightId,
                    "status": 'LOADING',
                    "type": {
                        "value": "highlight",
                        "updated": moment
                    },
                    "color": {
                        "value": selection.className,
                        "updated": moment
                    },
                    "quotation": {
                        "begin": selectionOffsetObject.start_pointer,
                        "end": selectionOffsetObject.end_pointer,
                        "text": selectionOffsetObject.selectionText.substr(0, 200),
                        "updated": moment
                    }
                };
                self.executeSubscriptions.call(this, onHighlightLoaded[newHighlightId], []);
                return newHighlightId;
            },

            commitTemporaryHighlight: function(tempHighlightUUID, newUUID) {
                var highlightIndex = highlightsCollection.length;
                var data;

                highlightsCollection.push(angular.element.extend(true, {}, temporaryHighlightsCollection[tempHighlightUUID]));
                delete temporaryHighlightsCollection[tempHighlightUUID];
                data = highlightsCollection[highlightIndex];
                data.status = 'LOADED';
                data.uuid = newUUID;
                self.executeSubscriptions.call(this, onHighlightsUpdate, []);

                //check if chapter is loaded, then load it or subscribe onchapterloaded
                data.position = {
                    start_pointer: DocumentService.parseCfiPosition(data.quotation.begin),
                    end_pointer: DocumentService.parseCfiPosition(data.quotation.end)
                };
                var chapterIndex = DocumentModel.getChapterIdByUrl(data.position.start_pointer.url);

                if (DocumentModel.checkIf.isChapterRendered(chapterIndex)) {
                    HighlightsService.createHighlight(data, chapterIndex);
                } else {
                    chaptersPromises[chapterIndex] = DocumentService.subscribe.onChapterRendered(chapterIndex, (function() {
                        var chapterPromise = chaptersPromises[chapterIndex];
                        var chapterId = chapterIndex;
                        var highlightObject = data;


                        return function() {
                            DocumentService.unsubscribe.onChapterRendered(chapterId, chapterPromise);
                            highlightObject.position = {
                                start_pointer: DocumentService.parseCfiPosition(data.quotation.begin),
                                end_pointer: DocumentService.parseCfiPosition(data.quotation.end)
                            };
                            HighlightsService.createHighlight(highlightObject, chapterId);
                        };
                    })())
                }
            },

            removeTemporaryHighlight: function(tempHighlightUUID) {
                var _tempHighlightUUID = tempHighlightUUID;

                return function(data) {
                    if (!!temporaryHighlightsCollection[_tempHighlightUUID]) {
                        delete temporaryHighlightsCollection[_tempHighlightUUID];
                        self.executeSubscriptions.call(this, onHighlightsUpdate, []);
                    };
                };
            },

            getHighlights: function() {
                return highlightsCollection.concat(Object.keys(temporaryHighlightsCollection).map(function(key) { return temporaryHighlightsCollection[key] }));
            },

            getHighlightByUuid: function(uuid) {
                return _.filter(highlightsCollection.concat(Object.keys(temporaryHighlightsCollection).map(function(key) { return temporaryHighlightsCollection[key] })), function(el, i) {
                    return el.uuid === uuid;
                })
            },

            getHighlightByIndex: function(highlightIndex) {
                return highlightsCollection[highlightIndex];
            },

            addHighlight: function(selection, highlightText) {
                var documentPath = DocumentModel.getDocumentPath(),
                    selectionObjectOffset = DocumentService.getSelectionObjectOffset(selection),
                    uniqTempHighlightID;
                uniqTempHighlightID = self.createTemporaryHighlight(documentPath, selection, selectionObjectOffset);

                NetworkService.addHighlight(documentPath, selectionObjectOffset).then(function(data) {
                    if (!!data && !!data.uuid) {
                        self.commitTemporaryHighlight(uniqTempHighlightID, data.uuid);
                        self.executeSubscriptions.call(this, onHighlightsUpdate, []);
                    } else {
                        throw 'Error while saving highlight';
                    }
                }).catch(self.removeTemporaryHighlight(uniqTempHighlightID));
            },

            removeHighlight: function(uuid, Highlight) {
                NetworkService.removeHighlight(DocumentModel.getDocumentPath(), uuid).then(function() {
                    self.executeSubscriptions.call(this, onHighlightsUpdate, []);
                });
                // console.log(highlightsCollection)
                for (var i = highlightsCollection.length - 1; i >= 0 && highlightsCollection[i].uuid !== uuid; i--) {};
                if (i >= 0) {
                    highlightsCollection.splice(i, 1);
                }
                HighlightsService.removeHighlight(uuid, Highlight);
            },

            getChapterHighlights: function(chapterUrl) {
                return _.filter(highlightsCollection.concat(Object.keys(temporaryHighlightsCollection).map(function(key) { return temporaryHighlightsCollection[key] })), function(el, i, obj) {

                    el.position = DocumentService.parseCfiPosition(el.quotation.begin);

                    return (el.status === 'LOADED' && el.position.url === chapterUrl);
                });
            }
        });
    }
    constructor.$inject = ["NetworkService", "DocumentModel", "DocumentService", "HighlightsService"];
}();